import {gql} from "apollo-boost";

export const DegreesQuery = gql`
    query Degrees($institutionId: Int!, $scheduleId: Int!) {
        degreesInscription(institutionId: $institutionId, scheduleId: $scheduleId){
            levelId
            programId
            degreeId
            description
        }
    }

`;


